import { AdminType, APIPost, APIPut, APIUrl } from "api/protocols";

interface IPostDeposit {
    facility_id: number;
    kind: "sale" | "capture" | "authorization";
    amount: number;
    customer_id: number;
}

interface IPutCaptureDeposit {
    deposit_id: number;
    payment_intent_id: string;
}

export async function PostCustomerBookingDeposit(params: IPostDeposit, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.Customer, "/deposit"), params, useGlobalLoader);
  }

  export async function PutCaptureCustomerBookingDeposit(params: IPutCaptureDeposit, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.Customer, "/deposit/capture"), params, useGlobalLoader);
  }